// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603101710/js/" + chunkId + "." + {"44":"253ee830","225":"3fae0229","481":"54d06857","486":"73ba8a6e","770":"63e9779e"}[chunkId] + ".0.5145585680203184.chunk.js";
};